module.exports = __webpack_public_path__ + "img/1483252435.3d8579d3.jpg";